import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-32 bg-nova-bg-alt" data-id="element-378">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-379">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-380">
          <h2 className="text-3xl md:text-4xl font-bold text-nova-text" data-id="element-381">
            ¿Tu Negocio Es <span className="text-red-500" data-id="element-382">Invisible</span> en
            Internet?
          </h2>
          <div className="w-16 h-[3px] bg-nova-accent mx-auto mt-4 mb-6" data-id="element-383" />
          <p className="text-lg text-nova-text-muted mb-4" data-id="element-384">
            Cada día que pasa sin una página web profesional, tu competencia te
            está ganando clientes.
          </p>
          <p className="text-lg text-nova-text-muted mb-12" data-id="element-385">
            Tus clientes potenciales te buscan en Google. Si no apareces...
            simplemente eligen a otro.
          </p>
        </motion.div>

        <div className="space-y-6 mb-12 text-left max-w-2xl mx-auto" data-id="element-386">
          {[{
          text: 'No tener página web dice: "No somos serios"'
        }, {
          text: 'Tener una página fea dice: "No nos importa la calidad"'
        }, {
          text: 'Tener una página lenta dice: "No valoramos tu tiempo"'
        }].map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-nova-card p-4 rounded-xl border border-red-500/10" data-id="element-387">
              <XCircle className="text-red-500 shrink-0" size={28} data-id="element-388" />
              <span className="text-nova-text font-medium text-lg" data-id="element-389">
                {point.text}
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-390">
          <p className="text-xl font-semibold text-nova-text mb-4" data-id="element-391">
            En 2026, un negocio sin presencia digital profesional es un negocio
            que está perdiendo dinero todos los días.
          </p>
          <p className="text-nova-accent font-semibold text-lg" data-id="element-392">
            Pero hay buenas noticias...
          </p>
        </motion.div>
      </div>
    </section>;
}